import {
  Box,
  Collapse,
  CollapseHeader,
  CollapsePanel,
  Text,
  useResponsiveValue,
} from "@vinomofo/components";
import { PropsWithChildren, useMemo, useState } from "react";

import { CircleMinusIcon } from "@vinomofo/icons";
import styled from "styled-components";
import { useInstantSearch } from "../../hooks/use-instantsearch";

/* istanbul ignore file */

interface FilterGroupProps {
  initiallyOpened: boolean;
  label: string;
  activeFiltersCount?: number;
}

const StyledCollapsePanel = styled(CollapsePanel)`
  overflow-x: auto;
`;

const ActiveFiltersText = styled(Text)`
  margin-left: 6px;
`;

export const FilterGroup = ({
  label,
  initiallyOpened,
  activeFiltersCount = 0,
  children,
}: PropsWithChildren<FilterGroupProps>): JSX.Element => {
  const { currentFilterGroup, toggleFilterGroup } = useInstantSearch();
  const [isOpen, setIsOpen] = useState(initiallyOpened);
  const isAccordion = useResponsiveValue([true, true, false]);
  const groupID = label.replace(/\s/g, "");

  return useMemo(
    () => (
      <Collapse
        data-group-id={groupID}
        data-current-id={currentFilterGroup}
        isOpen={isAccordion ? groupID === currentFilterGroup : isOpen}
        onClick={() => {
          if (isAccordion) {
            toggleFilterGroup(groupID === currentFilterGroup ? "" : groupID);
          } else setIsOpen(!isOpen);
        }}
        backgroundColor={isOpen ? "almostWhite" : "transparent"}
        borderBottom={[0, 0, "1px solid"]}
        borderColor={["divider", "divider", "divider"]}
      >
        <CollapseHeader
          closeIcon={<CircleMinusIcon />}
          p="20px"
          iconSize="16px"
          backgroundColor="transparent"
        >
          <Box display="flex" alignItems="center">
            <Text fontSize={2} fontWeight="500" color="button">
              {label}
            </Text>
            {activeFiltersCount > 0 && (
              <ActiveFiltersText fontSize={1} fontWeight="400">
                ({activeFiltersCount})
              </ActiveFiltersText>
            )}
          </Box>
        </CollapseHeader>
        <StyledCollapsePanel maxHeight={310} padding="0 20px 10px">
          {children}
        </StyledCollapsePanel>
      </Collapse>
    ),
    [children, isOpen, currentFilterGroup]
  );
};
